/* eslint-disable */
import classNames from 'classnames';
import React, { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import FolderTreeButton from 'layout/molecules/FolderTreeButton/FolderTreeButton';
import PlusSvg from 'images/v5/icons/plus.svg';
import Bar from 'layout/atoms/Bar';
import Button from 'layout/atoms/Button/Button';
import Caption from 'layout/atoms/Caption';
import { useDispatch } from 'react-redux';
import { openModal } from 'store/layoutSlice';
import styles from './FoldersTree.module.scss';
// type FoldersTreeItemProps = {
//   id: string;
//   name: string;
//   foldersCount: number;
//   parentId: string;
//   children: Folder[];
// };
function FoldersTree({ rootFolderId, folders = [], link }) {
    const { t } = useTranslation('specification');
    const dispatch = useDispatch();
    const wrapClasses = classNames(styles.wrap, styles.active);
    const [tree, setTree] = useState([]);
    const folderLink = link || '/specifications/folders';
    const buildTree = useCallback((rootFolderId, folders) => {
        const folderMap = new Map();
        const tree = [];
        folders.forEach((folder) => {
            folderMap.set(folder.id, Object.assign(Object.assign({}, folder), { children: [] }));
        });
        folders.forEach((folder) => {
            if (folder.parentId === rootFolderId) {
                tree.push(folderMap.get(folder.id));
            }
            else if (folderMap.has(folder.parentId)) {
                folderMap.get(folder.parentId).children.push(folderMap.get(folder.id));
            }
        });
        return tree;
    }, []);
    useEffect(() => {
        if (folders.length > 0 || rootFolderId) {
            const treeData = buildTree(rootFolderId, folders);
            setTree((prevTree) => {
                if (JSON.stringify(prevTree) !== JSON.stringify(treeData)) {
                    return treeData;
                }
                return prevTree;
            });
        }
        else {
            setTree([]);
        }
    }, [folders, rootFolderId, buildTree]);
    function Tree({ nodes, isRoot }) {
        if (!nodes || nodes.length === 0)
            return null;
        return (React.createElement("ul", { className: classNames(styles.list, { [styles.child]: !isRoot }) }, nodes.map((node, index) => (React.createElement(FolderTreeButton, { key: node.id, node: node, link: folderLink, isLast: index === nodes.length - 1, isRoot: isRoot }, node.children && node.children.length > 0 && React.createElement(Tree, { nodes: node.children }))))));
    }
    return (React.createElement("nav", { className: wrapClasses },
        React.createElement(Bar, { height: 24, hp: 8, aside: React.createElement(Button, { size: "xs", theme: "ghost", shape: "squared", leftIcon: React.createElement(PlusSvg, null), onClick: () => {
                    dispatch(openModal({ name: 'folderCreator' }));
                } }) },
            React.createElement(Caption, { color: "subtle" }, t('FOLDERS'))),
        React.createElement("main", { className: styles.main },
            React.createElement(Tree, { nodes: tree, isRoot: true }))));
}
export default FoldersTree;
